import { Link } from 'react-router-dom';
import { useState } from 'react';
import apiService from '../../services/api';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ type: 'error', text: 'الرجاء إدخال بريدك الإلكتروني' });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ type: 'error', text: 'الرجاء إدخال بريد إلكتروني صحيح' });
      return;
    }

    try {
      setLoading(true);
      setMessage({ type: '', text: '' });
      await apiService.subscribeToNewsletter(email);
      setMessage({ type: 'success', text: 'تم الاشتراك بنجاح! شكراً لك' });
      setEmail('');
      
      // Clear success message after 3 seconds
      setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 3000);
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setMessage({ 
        type: 'error', 
        text: error.message || 'حدث خطأ، الرجاء المحاولة لاحقاً' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="relative z-10 bg-gradient-to-br from-primary via-primary-dark to-blue-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-6 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          
          {/* Brand Section */}
          <div className="col-span-2 md:col-span-1 space-y-3 md:space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src="/RIGHTALLEMNI.png" 
                alt="Allemni" 
                className="h-12 md:h-16 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-blue-100 text-xs md:text-sm leading-relaxed hidden md:block">
              منصة تعليمية حديثة باش نتعلموا الفرنسية بالدارجة - دورات وقصص تفاعلية للكبار والصغار
            </p>
            {/* Social Media Icons */}
            <div className="flex gap-2 md:gap-3">
              <a 
                href="#" 
                className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook text-sm md:text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram text-sm md:text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="YouTube"
              >
                <i className="fab fa-youtube text-sm md:text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-9 h-9 md:w-10 md:h-10 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin text-sm md:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 flex items-center gap-2">
              <i className="fas fa-link text-sm md:text-base"></i>
              روابط سريعة
            </h3>
            <ul className="space-y-1.5 md:space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  من نحن
                </Link>
              </li>
              <li>
                <Link 
                  to="/courses" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  الدورات
                </Link>
              </li>
              <li>
                <Link 
                  to="/storybooks" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  القصص المصورة
                </Link>
              </li>
              <li>
                <Link 
                  to="/pricing" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  الأسعار
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-span-1">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 flex items-center gap-2">
              <i className="fas fa-headset text-sm md:text-base"></i>
              الدعم
            </h3>
            <ul className="space-y-1.5 md:space-y-2">
              <li>
                <Link 
                  to="/contact" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  اتصل بنا
                </Link>
              </li>
              <li>
                <a 
                  href="tel:0558501409" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-phone text-xs"></i>
                  0558501409
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@allemani.dz" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-envelope text-xs"></i>
                  info@allemani.dz
                </a>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  سياسة الخصوصية
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-blue-100 hover:text-white hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-300 text-xs md:text-sm"
                >
                  <i className="fas fa-chevron-left text-xs"></i>
                  شروط الاستخدام
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 flex items-center gap-2">
              <i className="fas fa-envelope text-sm md:text-base"></i>
              باقي في التواصل
            </h3>
            <p className="text-blue-100 text-xs md:text-sm mb-3 md:mb-4">
              سجّل باش توصلك كل جديد والعروض لي عندنا
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-2">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="بريدك الإلكتروني"
                  disabled={loading}
                  className="flex-1 px-3 py-2 text-xs md:text-sm rounded-xl bg-white/10 border border-white/20 text-white placeholder-blue-200 focus:outline-none focus:bg-white/20 focus:border-white/40 transition-all disabled:opacity-50"
                />
                <button 
                  type="submit"
                  disabled={loading}
                  className="px-3 md:px-4 py-2 bg-white text-primary font-bold rounded-xl hover:bg-blue-50 transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                >
                  {loading ? (
                    <i className="fas fa-spinner fa-spin text-sm"></i>
                  ) : (
                    <i className="fas fa-paper-plane text-sm"></i>
                  )}
                </button>
              </div>
              {message.text && (
                <p className={`text-xs ${
                  message.type === 'success' 
                    ? 'text-green-300' 
                    : 'text-red-300'
                } animate-fade-in`}>
                  {message.text}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-3 md:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-4 text-xs md:text-sm text-blue-100">
            <p className="flex items-center gap-2">
              <i className="fas fa-copyright"></i>
              {currentYear} Allemni. كل الحقوق محفوظة
            </p>
            <p className="flex items-center gap-2">
              <i className="fas fa-code"></i>
              صُنع بكل حب 
              <span className="text-red-400 animate-pulse">❤</span>
              من الجزائر
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
